<script setup lang="ts">
    defineProps<{
        total: number
        current: number
    }>();
</script>

<template>
    <div class="progress-bar">
        <div
            v-for="n in total"
            :key="n"
            class="progress-bar__step"
        >
            <span
                :class="{
                    'progress-bar__step__bar--current': n === current,
                    'progress-bar__step__bar--done': n < current,
                }"
                class="progress-bar__step__bar"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.progress-bar{
    display: flex;
    justify-content: space-between;
    padding: var(--spacing-02);
    gap: var(--spacing-02);
    inline-size: 100%;

    @include min-width(md) {
        padding-block: var(--spacing-04);
        padding-inline: var(--spacing-05);
    }

    @include min-width(lg) {
        padding-block: var(--spacing-04);
        padding-inline: var(--spacing-07);
    }

    &__step {
        flex: 1;
        border-radius: var(--border-radius-rounded);
        background: var(--background-secondary);
        block-size: var(--size-0);

        &__bar {
            display: block;
            border-radius: var(--border-radius-rounded);
            background: var(--widget-brand-color);
            block-size: 100%;
            inline-size: 0;

            &--current {
                inline-size: 50%;
            }

            &--done {
                inline-size: 100%;
            }
        }
    }
}
</style>
